import { MINUTES } from '@sequencehq/utils/dates'

/**
 * Time since contact last viewed to be considered online.
 * Matches the delay used by the backend to record another view by the same user.
 */
export const ONLINE_THRESHOLD: number = 5 * MINUTES
